import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.505 22a.998.998 0 0 1-.71-1.71L16.087 12 7.795 3.71a1.005 1.005 0 0 1 1.419-1.42l8.99 9a1 1 0 0 1 0 1.42l-8.99 9a1 1 0 0 1-.71.29"
    />
  </svg>
);
export default SvgChevronRight;
